import store from 'store'
function closeLoding () {
  store.commit('SET_LOADING', false)
}
function openLoading () {
  store.commit('SET_LOADING', true)
}
export {closeLoding, openLoading}



// WEBPACK FOOTER //
// ./src/common/utils/mixed.js